import { render, staticRenderFns } from "./postAuditList.vue?vue&type=template&id=1d2e3686&"
import script from "./postAuditList.vue?vue&type=script&lang=js&"
export * from "./postAuditList.vue?vue&type=script&lang=js&"
import style0 from "./postAuditList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports